<template>
    <div class="dashboard">
        <div class="content-area">
            <base-header
                :menu-listing="menuListing"
                @sidemenu="$emit('responsiveSideBar')"
            ></base-header>
            <div class="right-panel">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            menuListing: [
                {
                    anchorLink: '/insights/alerts',
                    menuLabel: 'Alerts',
                    name: 'view-alerts',
                    permission: ['view-alerts'],
                },
                {
                    anchorLink: '/insights/activity-dashboard',
                    name: 'view-activity-dashboard',
                    permission: ['view-activity-dashboard'],
                    menuLabel: 'Activity Dashboard',
                    dataLength: 0,
                },
                {
                    anchorLink: '/insights/customer-statistics',
                    name: 'view-customer-statistics',
                    permission: ['view-customer-statistics'],
                    menuLabel: 'Customer Statistics',
                },
            ],
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {}, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getAlertsLength(this.dataSegmentId).then((dataLength) => {
            this.menuListing[1].dataLength = dataLength
        })
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        async getAlertsLength(dataSegmentId) {
            const { data } = await request({
                url: `/alerts/getLength/${dataSegmentId}`,
                method: 'get',
            })
            // this.menuListing[1].dataLength =  data.data
            return data.data
        },
    }, // End of Component > mounted
} // End of export default
</script>
